import React from 'react'
import {Routes , Route} from "react-router-dom"
import Home from './components/Home'
import Aboutus from './components/Aboutus'
import Contact from './components/Contact'
import Privacypolicy from './components/Privacypolicy'
import Disclaimer from './components/Disclaimer '
import Appdetails from './components/Appdetails'
import Analytics from "./Analytics";
export default function App() {
  return (
    <div>
       <Analytics />
     <Routes>
      <Route element={<Home />} path='/'/>
      <Route element={<Aboutus/>} path='/aboutus' />
      <Route element={<Contact/>} path='/contact' />
      <Route element={<Privacypolicy/>} path='/privacypolicy' />
      <Route element={<Disclaimer/>} path='/disclamier' />
      <Route path="/allapp/:id" element={<Appdetails />} />
     </Routes>
    </div>
  )
}
